import BaseModel from './BaseModel'

export default class VehiclePart extends BaseModel {
  // ... VehiclePart-specific methods or overrides ...
}
